import React, { useState } from 'react'

import Modal from 'src/components/shared/modal'
import { JOB_STATUS, TASK_VIEW } from 'src/constants'
import Button from 'src/components/shared/button'

import TaskInfo from './task-info'
import RateTaskQuality from './rate-task-quality'
import ManualTaskComplete from './manual-task-complete'

export type ViewType = 'info' | 'task-quality' | 'manual-complete'

type Props = {
    open: boolean,
    data?: LocationType
    setOpen: (isOpen: boolean) => void
}
const TaskModal: React.FC<Props> = ({ open, setOpen, data }) => {

    const [view, setView] = useState<ViewType>(TASK_VIEW.info)
  
    const workerPlan = data?.worker_plans?.[0]
    const task = data?.worker_actuals?.[0]

    const payload = {
        reportingUserId: "2772b55f-66f3-45d9-8614-c3d148fe2037",
        notes: "Reporting task as complete.",
        modality: "mobile"
    }

    const taskNotInProgress = task?.task_state !== JOB_STATUS.progress && (view !== TASK_VIEW.taskQuality && view !== TASK_VIEW.manualComplete ) 

    const onTaskViewChange = () => {
        if (task?.task_state === JOB_STATUS.complete) {
            setView(TASK_VIEW.taskQuality)
        } else {
            setView(TASK_VIEW.manualComplete)
        }
    }

    return (
        <Modal open={open}>
            <div className=" sm:items-start w-full  max-w-[450px]">
                <div className="mt-4 sm:ml-4 sm:mt-0 sm:text-left">
                    <h3 className="text-xl font-semibold leading-6 text-center pb-5 text-gray-900" id="modal-title">
                    {workerPlan?.worker?.first_name} {workerPlan?.worker?.last_name}
                 </h3>
                    {view === TASK_VIEW.taskQuality && (
                        <RateTaskQuality setOpen={setOpen} setView={setView} />
                    )}
                    {view === TASK_VIEW.info && (
                       <TaskInfo 
                       task={task!}
                       worker={workerPlan}
                       color={data?.color}
                       locationMoniker={data?.location_moniker!}
                   />
                    )}
                    {view === TASK_VIEW.manualComplete && (
                       <ManualTaskComplete
                       setOpen={setOpen}
                       payload={payload}
                       workerPlanId={workerPlan?.id}
                       workerId={workerPlan?.worker?.id}
                       setView={setView} />
                    )}<div>
                        <div className='flex flex-col'>
                            {taskNotInProgress ? (
                                <div className='w-full mt-3'>
                                    <Button
                                    onClick={onTaskViewChange}>
                                    {task?.task_state === JOB_STATUS.complete ? ' Rate Task Quality' : 'Complete Task?'}
                                </Button>
                                </div>
                            ) : null}
                            <div className={`w-full  ${task?.task_state !== JOB_STATUS.progress? 'mt-2': 'mt-8'}`}>
                               <Button variants='outline'
                                    onClick={() => { setOpen(!open); setView(TASK_VIEW.info) }}>
                                    Close
                             </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default TaskModal
